export default "__VITE_ASSET__Cu1ueF1B__"